<div class="my-reports__container card">
  <dx-scroll-view class="my-reports__scroll-view" [useNative]="false" [showScrollbar]="'always'">
    <div class="my-reports__sections">
      @for (section of sectionsSig(); track section.id) {
        <div class="my-reports__section">
          <div class="my-reports__section-header">
            <h3 class="my-reports__section-title">{{ section.title }}</h3>
          </div>
          @for (group of section.groups; track $index) {
            <div class="my-reports__group">
              @if (group.title) {
                <h4 class="my-reports__group-title">{{ group.title }}</h4>
              }
              <div class="my-reports__tiles">
                @for (tile of group.tiles; track tile.name) {
                  <div class="my-reports__tile" (click)="openTile(tile, section)">
                    <span class="my-reports__tile-title">{{ tile.name }}</span>
                    <span class="my-reports__tile-description">{{ tile.description }}</span>
                    @if (reportIdOf(tile); as reportId) {
                      @if (canManageDefaultsSig()) {
                        <dx-button
                          class="my-reports__tile-settings-button"
                          icon="preferences"
                          stylingMode="text"
                          hint="Report default settings"
                          (onClick)="onSettingsClick($event, reportId)"
                        ></dx-button>
                      }
                    }
                  </div>
                }
              </div>
            </div>
          }
        </div>
      }
    </div>
  </dx-scroll-view>
</div>

<dx-load-panel
  [visible]="isOpeningReportSig()"
  [showIndicator]="true"
  [showPane]="true"
  [shading]="true"
  [hideOnOutsideClick]="false"
  [message]="'Opening report...'"
></dx-load-panel>

<ag-shr-report-default-settings-modal #reportDefaultSettingsModalRef></ag-shr-report-default-settings-modal>
